"use client";

import React from "react";
import { Button } from "../../button.js";
import { LucideIcon } from "lucide-react";

interface ActionButton {
  label: string;
  icon?: LucideIcon;
  onClick: () => void;
  variant?: "default" | "outline" | "ghost" | "destructive";
  size?: "sm" | "md" | "lg";
  disabled?: boolean;
}

interface ActionButtonGroupProps {
  buttons: ActionButton[];
  orientation?: "horizontal" | "vertical";
  className?: string;
}

export function ActionButtonGroup({
  buttons,
  orientation = "horizontal",
  className = ""
}: ActionButtonGroupProps) {
  const orientationClasses = orientation === "horizontal" 
    ? "flex items-center space-x-2"
    : "flex flex-col space-y-2";

  return (
    <div className={`${orientationClasses} ${className}`}>
      {buttons.map((button, index) => {
        const Icon = button.icon;
        return (
          <Button
            key={index}
            variant={button.variant || "outline"}
            size={button.size === "md" ? "default" : (button.size || "sm")}
            onClick={button.onClick}
            disabled={button.disabled}
            className="flex items-center space-x-2"
          >
            {Icon && <Icon className="h-4 w-4" />}
            <span>{button.label}</span>
          </Button>
        );
      })}
    </div>
  );
}
